'use strict';

angular.module('msCommunity').controller('CommunityDiscussionCtrl', ['discussionSvc', 'overlaySvc', 'activity', '$stateParams', function (discussionSvc, overlaySvc, activity, $stateParams) {
  var vm = this;
  vm.replyId = $stateParams.replyId;
  vm.activity = activity;

  vm.newDiscussion = {
    content: '',
    topic: activity.url,
    activityId: activity.id
  };

  vm.showCommunityGuidelines = function () {
    overlaySvc.overlay('youth.overlay.community_guidelines', { icon: 'fa fa-group' });
  };

  vm.addDiscussion = function (discussion) {
    if (!discussion.content) {
      return;
    }
    discussionSvc.post(discussion).then(function (resp) {
      vm.activity.discussions.push(resp);
      discussion.content = '';
    });
  };

  vm.removeDiscussion = function (discussionId) {
    vm.activity.discussions.forEach(function (discussion) {
      if (discussionId === discussion.id) {
        discussion.flag = 'ANYTHING_BUT_FAVORITE';
      }
    });
  };
}]);